import { VENUE_TYPE_COLORS, VENUE_TYPE_ICONS } from "@/constants/venueTypes";

// If you want: also export baseBlue or other shared styling constants here.

export function makeVenuePinDiv(venue) {
  const color = VENUE_TYPE_COLORS[venue.venue_type] || VENUE_TYPE_COLORS["Other"];
  const iconName = VENUE_TYPE_ICONS[venue.venue_type] || VENUE_TYPE_ICONS["Other"];

  const markerContent = document.createElement("div");
  markerContent.style.cssText = `
    background-color: ${color};
    width: 40px;
    height: 50px;
    border-radius: 50% 50% 50% 0;
    transform: rotate(-45deg);
    border: 3px solid white;
    box-shadow: 0 4px 8px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  `;

  const iconWrapper = document.createElement("div");
  iconWrapper.style.cssText = `
    transform: rotate(45deg);
    color: white;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  `;
  iconWrapper.className = "material-symbols-outlined";
  iconWrapper.textContent = iconName;

  markerContent.appendChild(iconWrapper);
  return markerContent;
}